import React from "react";

type Props = {
  rows?: number;
};

const Cell = ({ className }: { className: string }) => (
  <div className={`h-3 rounded bg-gray-200 animate-pulse ${className}`} />
);

export const BookingsTableSkeleton: React.FC<Props> = ({ rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i} className="text-center odd:bg-white even:bg-gray-50">
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <Cell className="w-24 mx-auto" />
          </td>
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <div className="flex flex-col gap-2 min-w-[180px]">
              <div className="flex items-center gap-2 p-2 rounded-lg border border-gray-200 bg-white">
                <div className="h-5 w-10 rounded bg-gray-200 animate-pulse" />
                <Cell className="w-20" />
              </div>
              <div className="flex items-center gap-2 p-2 rounded-lg border border-gray-200 bg-white">
                <div className="h-5 w-10 rounded bg-gray-200 animate-pulse" />
                <Cell className="w-20" />
              </div>
            </div>
          </td>
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <div className="flex justify-center">
              <div className="h-5 w-20 rounded-full bg-gray-200 animate-pulse" />
            </div>
          </td>
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <div className="flex justify-center">
              <div className="h-5 w-16 rounded-full bg-gray-200 animate-pulse" />
            </div>
          </td>
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <div className="space-y-2">
              <Cell className="w-20 mx-auto" />
              <Cell className="w-14 mx-auto" />
            </div>
          </td>
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <div className="space-y-2">
              <Cell className="w-20 mx-auto" />
              <Cell className="w-14 mx-auto" />
            </div>
          </td>
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <div className="flex justify-center">
              <div className="h-6 w-24 rounded-full bg-gray-200 animate-pulse" />
            </div>
          </td>
          <td className="px-2 py-2 sm:px-4 sm:py-3 border-t border-gray-200">
            <div className="flex justify-center">
              <div className="h-9 w-12 rounded-lg bg-gray-200 animate-pulse" />
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default BookingsTableSkeleton;
